import CheckOutlined from '@mui/icons-material/CheckOutlined';
import RemoveOutlined from '@mui/icons-material/RemoveOutlined';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

interface FilterCheckboxProps {
  checked: boolean;
  indeterminate?: boolean;
}

export function FilterCheckbox({ checked, indeterminate }: FilterCheckboxProps): ReactNode {
  const filled = checked || indeterminate;
  return (
    <Box
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 16,
        height: 16,
        borderRadius: 0.5,
        border: '1.5px solid',
        borderColor: filled ? theme.palette.primary.main : theme.palette.border.strong,
        bgcolor: filled ? theme.palette.primary.main : theme.palette.background.paper,
        flexShrink: 0,
      })}
    >
      {indeterminate ? (
        <RemoveOutlined sx={{ fontSize: 11, color: 'white' }} />
      ) : checked ? (
        <CheckOutlined sx={{ fontSize: 11, color: 'white' }} />
      ) : null}
    </Box>
  );
}
